import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
export interface customer {
  id: number;
  name: string;
  address: string;
  day_of_week: number;
  phone_number: string;
  status: string;
}

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  private API_CUSTOMER = "/api/customer"
  private contentTypeJson = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }
  constructor(private httpClient: HttpClient) { }

  newAccount(customer: any) {
    return this.httpClient.post(this.API_CUSTOMER, customer, this.contentTypeJson);
  }
  update(customer: any) {
    return this.httpClient.put(this.API_CUSTOMER, customer, this.contentTypeJson);
  }
  getAll() {
    return this.httpClient.get<customer[]>(this.API_CUSTOMER);
  }
  getByID(id: number) {
    const path = `${this.API_CUSTOMER}/${id}`
    return this.httpClient.get<customer>(path);
  }
}
